import { Injectable } from '@angular/core';
import { HttpService } from '../service/http.service';
import { LeadType } from '../lead-type';

@Injectable({
  providedIn: 'root'
})
export class LeadsFilterService {

  searchOptions = [
    { label: "Name", value: 1, placeholder: "search by name" },
    { label: "School", value: 2, placeholder: "search by school" },
    { label: "Destination", value: 3, placeholder: "search by destination" },
    { label: "Email", value: 4, placeholder: "search by email" }
  ];
  searchOption: any;
  selectedLeadType: LeadType | null;
  selectedDisplayOption: any;
  leadTypes: LeadType[] = [];
  defaultLeadType = null;

  displayOptions = [
    { label: "Show all", value: 0 },
    { label: "New & Processing", value: 1},
    { label: "New", value: 2 },
    { label: "Processing", value: 3 },
    { label: "Done", value: 4 },
    { label: "Deleted", value: 5 }
  ];

  constructor(
    private httpService: HttpService
  ) {
    this.searchOption = this.searchOptions[0];
    this.selectedDisplayOption = this.displayOptions[1].value;
    this.selectedLeadType = null;
    this.httpService.getLeadTypes().subscribe(res => {
      this.leadTypes = res;
      this.leadTypes.unshift(new LeadType(0, "All"));
      this.selectedLeadType = this.leadTypes[0];
    });
   }
}
